document.addEventListener('DOMContentLoaded', function() {
    console.log("Prizmatique Engine: Online");

    const soundUrl = "/s/files/1/0597/4618/9484/files/Prism_Refraction.MP3?v=1770723783";
    const prizmAudio = new Audio(soundUrl);
    prizmAudio.load(); // Pre-loads the "chicken wings" sound

    const dynamicBtn = document.querySelector('#btn-dynamic');
    const cosmicBtn = document.querySelector('#btn-cosmic');
    const preloader = document.getElementById('preloader');
    
    function startEntrance(path) {
        console.log("Refraction Sequence: Started");

        // 1. Trigger Sound
        prizmAudio.play().catch(e => console.log("Audio Blocked:", e));

        // 2. Trigger Animation (The White Flash)
        if (preloader) {
            preloader.style.transition = "background-color 1.0s ease-in-out";
            preloader.style.backgroundColor = "#ffffff";
        }

        // 3. Travel to Collection
        setTimeout(() => {
            window.location.href = (path === 'dynamic') ? '/collections/dynamic-collection' : '/collections/cosmic-collection';
        }, 2000);
    }

    if(dynamicBtn) dynamicBtn.addEventListener('click', () => startEntrance('dynamic'));
    if(cosmicBtn) cosmicBtn.addEventListener('click', () => startEntrance('cosmic'));
});